import "./App.css";
import React, { Component } from "react";
import axiosInstance from "./api/axiosInstance";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  Redirect
} from "react-router-dom";

import Login from "./component/Login/Login";
import Forgot from "./component/Login/Forgot";
import ResetPasswordComponent from "./component/Login/ResetPassword";
import MiniDrawer from "./component/Drawerpage/Drawerpage.jsx";
import NotificationComponent from "./component/Notification/Notification.jsx";
import PrivacyPolicy from "./component/PrivacyPolicy/PrivacyPolicy";

import Cookies from "js-cookie";
import moment from "moment";
import history from "./route";
import { initEncryptionSession } from "./encryptionSession";

/* ================= API CONFIG ================= */
const API_BASE = import.meta.env.VITE_API_URL || "https://health.orangehealth.online/";
export const apiurl = API_BASE;
export const paymentsuccessurl = window.location.origin + "/paymentsuccess";

export const SupportNameFn = (val) => {
  const SideName = [
    {
      "id": 1,
      "en": "Home",
      "ar": "بيت"
    },
    {
      "id": 2,
      "en": "Total Prescriptions",
      "ar": "مجموع الوصفات"
    },
    {
      "id": 3,
      "en": "Pending Quotes",
      "ar": "الأسعار المعلقة"
    },
    {
      "id": 4,
      "en": "Pending Approvals",
      "ar": "الموافقات المعلقة"
    },
    {
      "id": 5,
      "en": "Pending Orders",
      "ar": "الأوامر المعلقة"
    },
    {
      "id": 6,
      "en": "Completed Prescriptions",
      "ar": "الوصفات الطبية المكتملة"
    },
    {
      "id": 7,
      "en": "Canceled Quotes",
      "ar": "عروض الأسعار الملغاة"
    },
    {
      "id": 8,
      "en": "Revenue & Settlement",
      "ar": "الدخل والتسوية"
    },
    {
      "id": 9,
      "en": "Manage Medicine",
      "ar": "إدارة الطب"
    },
    {
      "id": 10,
      "en": "Support",
      "ar": "الدعم"
    },
    {
      "id": 11,
      "en": "Profile",
      "ar": "الملف الشخصي"
    }
  ];

  const language = localStorage.getItem("pharmacy_language");

  let result = SideName.filter(item => {
    if (item.en === val || item.ar === val) {
      return language === 'en' ? item.en : item.ar;
    }
    return null; // If no match is found, return null
  });

  console.log(result, 'result of val check');
  return result.length > 0 ? result[0][language] : ''; // Return the first matched value in the selected language, or an empty string if no match found
}

/* ================= LOGOUT ================= */
let isLoggingOut = false;

export async function logout() {
  if (isLoggingOut) return;
  isLoggingOut = true;

  try {
    const token = Cookies.get("tokenHeader");
    if (token) {
      await axiosInstance.post("admin/logout", {
        userId: Cookies.get("Doctor_id"),
        reason: "PHARMACY USER LOGOUT – TOKEN EXPIRED"
      });
    }
  } catch (err) {
    console.warn("Logout API failed:", err?.message);
  } finally {
    Object.keys(Cookies.get()).forEach((c) => Cookies.remove(c));
    history.replace("/");
  }
}

/* ================= AXIOS INTERCEPTORS ================= */
// export function setupAxiosInterceptors() {
//   const publicUrls = [
//     "pharmacy/LoginWeb",
//     "pharmacy/ForgotPassword",
//     "pharmacy/ResetPassword",
//     "admin/logout"
//   ];

//   axios.interceptors.request.use(
//     (config) => {
//       if (publicUrls.some((u) => config.url.includes(u))) return config;

//       const token = Cookies.get("tokenHeader");
//       const expiry = Cookies.get("tokenExpiry");

//       if (!token || !expiry || new Date(expiry) <= new Date()) {
//         logout();
//         return Promise.reject("Token expired");
//       }

//       config.headers.Authorization = `Bearer ${token}`;
//       return config;
//     },
//     (error) => Promise.reject(error)
//   );

//   axios.interceptors.response.use(
//     (res) => res,
//     (err) => {
//       if (err.response?.status === 401) logout();
//       return Promise.reject(err);
//     }
//   );
// }

/* ================= PRIVATE ROUTE ================= */
const PrivateRoute = ({ component: Component, ...rest }) => (
  <Route
    {...rest}
    render={(props) =>
      Cookies.get("clinic_id") ? <Component {...props} /> : <Redirect to="/" />
    }
  />
);

/* ================= UTIL FUNCTIONS ================= */
export const timerDifference = (data) => {
  const time =
    Date.parse(new Date()) -
    Date.parse(moment(data).format("YYYY-MM-DD HH:mm:ss"));

  const h = Math.floor(time / (1000 * 60 * 60));
  const m = Math.floor((time / 1000 / 60) % 60);
  const s = Math.floor((time / 1000) % 60);

  return `${pad(h)}:${pad(m)}:${pad(s)}`;
};

const pad = (n) => (n < 10 ? "0" + Math.abs(n) : Math.abs(n));

export const formatMoney = (n) =>
  n == null || isNaN(n)
    ? ""
    : Number(n).toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });

/* ================= APP CLASS ================= */
export default class App extends Component {
  componentDidMount() {
    // 🔐 Encryption session
    initEncryptionSession().catch(console.error);

    // 🛡 Axios interceptor (ONCE)
    // setupAxiosInterceptors();
  }

  render() {
    return (
      <div>
        {/* {this.state.renderData == true && */}
        <Router>
          <Route exact path="/" component={Login} />
          <Route path={"/forgot"} component={Forgot} />
          <Route path="/ResetPassword/:uuid" component={ResetPasswordComponent} />
          <Route path="/Home" component={MiniDrawer} />
          <Route path="/PrivacyPolicy" component={PrivacyPolicy} />
          <Route path="/notification" component={NotificationComponent} />
        </Router>
        {/* <Notification /> */}
        {/* } */}
      </div>
    );
  }
}
